function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewEmailIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.83,252.47c-5.48-8.22-18.56-10.65-28.9-14s-16.43-10-13.69-26.46,17-43.2,16.73-48.07-49.28-4.56-53.85-3-5.47,1.21-9.73,6.69A75.83,75.83,0,0,0,281,177l5.28-11.1.39,0a14,14,0,0,1,2.41-4,30.75,30.75,0,0,0,7.45-19.34c.2-10.47-7.25-9.46-8.66-6.24s-9.66,14.3-12.08,17.32-7.45,11.28-7.45,11.28l-5.59,19.38s-1.22,5.78-8.22,27.69S250.58,244,250.58,244s-1.83-.91-6.09,12.17-2.43,29.81,5.17,37.72,17.65,7.61,28.91,3.05A34.61,34.61,0,0,0,295,282.28s11.87-3,20.69-9.73S331.2,258.86,344,259.47s27.38,7.91,32.25,7.6S382.31,260.68,376.83,252.47Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.86,199.5a372.7,372.7,0,0,0-9.36-38.24c-11.4-36.39-34.09-73.21-73.06-85.59-28.77-9.13-59.82-2.83-84.13,15.78-38.13,29.18-65.88,69-107.6,94.27-34.83,21.11-53.06,55.21-41.35,103.41S136.19,365.41,179,362c35.58-2.87,72.78.2,103.54,17.47,27.49,15.43,76.06,2,116.24-40.15,23.41-24.57,21.14-55.81,13.51-85C407.57,236.24,404.51,217.8,400.86,199.5Z",
    style: {
      fill: "#EDDBC6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.86,199.5a372.7,372.7,0,0,0-9.36-38.24c-11.4-36.39-34.09-73.21-73.06-85.59-28.77-9.13-59.82-2.83-84.13,15.78-38.13,29.18-65.88,69-107.6,94.27-34.83,21.11-53.06,55.21-41.35,103.41S136.19,365.41,179,362c35.58-2.87,72.78.2,103.54,17.47,27.49,15.43,76.06,2,116.24-40.15,23.41-24.57,21.14-55.81,13.51-85C407.57,236.24,404.51,217.8,400.86,199.5Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.41,423.48c0,3.12-85,5.66-189.82,5.66S61.76,426.6,61.76,423.48s85-5.66,189.83-5.66S441.41,420.36,441.41,423.48Z",
    style: {
      fill: "#EDDBC6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.41,423.48c0,3.12-85,5.66-189.82,5.66S61.76,426.6,61.76,423.48s85-5.66,189.83-5.66S441.41,420.36,441.41,423.48Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.07,314.51c0,.05,2.57-2.65,2.71-2.84,1.63-2.18,3.5-7.36,1.73-9.85a3.61,3.61,0,0,0-5.35-.46c-1.62,1.42-2,4.05-1.86,6.08C402.47,309.82,405.07,314.5,405.07,314.51Z",
    style: {
      fill: "#EDDBC6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.43,305.21c-2.5-1.75-7.66.16-9.83,1.8-.19.15-2.87,2.71-2.82,2.73l.06,0c-.82.3-1.69.62-2.64,1-1.74.7-3.7,1.52-5.78,2.54a67.73,67.73,0,0,0-6.54,3.64,47,47,0,0,0-6.66,5.06.46.46,0,0,0-.07.07c.44-.77,1.61-3,1.68-3.16,1-2.54,1.43-8-.93-9.95a3.62,3.62,0,0,0-5.29,1c-1.18,1.8-.86,4.43-.18,6.35.76,2.17,4.21,5.75,4.49,6a63.23,63.23,0,0,0-5.76,6.29c-1,1.29-2.05,2.62-3,4,.36-.68.68-1.3.71-1.39,1-2.53,1.43-8-.93-9.95a3.61,3.61,0,0,0-5.28,1c-1.19,1.79-.86,4.43-.19,6.34s3.57,5.07,4.34,5.88L382.64,336c-1.8,2.51-3.58,5-5.41,7.42-.64.85-1.3,1.67-2,2.48.32-.61.59-1.12.62-1.2,1-2.54,1.43-8-.93-10a3.61,3.61,0,0,0-5.29,1c-1.19,1.8-.86,4.43-.18,6.35s3.28,4.76,4.19,5.73c-.7.82-1.4,1.63-2.12,2.39-.5.51-.94,1-1.48,1.51l-1.53,1.44c-1,.88-2,1.8-3.05,2.64-.7.59-1.37,1.13-2,1.68.64-.83,1.88-2.5,2-2.65a14,14,0,0,0,1.64-6.88,4.74,4.74,0,0,0,.34-.72,3.62,3.62,0,0,0-2.39-4.82c-3-.73-7.1,2.9-8.53,5.22-.08.14-.84,1.72-1.29,2.73.17-.63.36-1.25.53-1.9.36-1.29.68-2.59,1-4,.14-.68.29-1.37.44-2.06s.24-1.43.37-2.15c.25-1.68.43-3.39.58-5.12,1.13.31,5.16,1.36,7.18,1s4.49-1.26,5.51-3.15a3.6,3.6,0,0,0-1.63-5.12c-2.82-1.18-7.45,1.79-9.22,3.86-.11.13-1.21,1.76-1.8,2.67.08-1,.16-2.08.21-3.14.12-3,.16-6.13.21-9.21,0-.94,0-1.88.06-2.82.4.11,5.17,1.46,7.43,1.11,2-.3,4.49-1.25,5.52-3.15a3.62,3.62,0,0,0-1.64-5.12c-2.81-1.17-7.45,1.8-9.22,3.87-.13.15-1.71,2.5-2.09,3.12.05-2.07.12-4.14.27-6.17a64.83,64.83,0,0,1,1.1-8.17c.19,0,5.16,1.48,7.48,1.12,2-.3,4.48-1.25,5.51-3.15a3.62,3.62,0,0,0-1.63-5.12c-2.82-1.17-7.46,1.79-9.22,3.87-.12.13-1.33,1.92-1.88,2.78l-.16-.06a46.16,46.16,0,0,1,2.57-7.89c.58-1.41,1.21-2.72,1.86-4,.9.36,5,2,7.14,1.88s4.6-.76,5.83-2.53a3.62,3.62,0,0,0-1.06-5.27c-2.67-1.47-7.61,1-9.59,2.83-.11.1-1.09,1.25-1.8,2.1.3-.56.6-1.15.9-1.69,1.12-2,2.26-3.8,3.29-5.37.59-.88,1.14-1.67,1.67-2.41,1.06-.1,5.36-.59,7.17-1.62s3.73-2.79,4-4.93a3.6,3.6,0,0,0-3.37-4.18c-3.05-.08-6.3,4.35-7.2,6.92-.08.23-.9,3.84-.85,3.83h.07q-.78,1-1.65,2.28c-1.07,1.55-2.26,3.31-3.42,5.31a65,65,0,0,0-3.45,6.64,48,48,0,0,0-2.77,7.9.3.3,0,0,1,0,.1c0-.89-.3-3.38-.34-3.57-.56-2.66-3.23-7.48-6.26-7.78a3.61,3.61,0,0,0-3.88,3.72c0,2.15,1.73,4.17,3.35,5.39,1.83,1.39,6.68,2.48,7.07,2.56a65,65,0,0,0-1.33,8.43c-.15,1.65-.26,3.31-.35,5-.07-.77-.14-1.46-.16-1.55-.57-2.67-3.24-7.48-6.27-7.79a3.61,3.61,0,0,0-3.88,3.72c0,2.15,1.73,4.17,3.35,5.4s5.77,2.25,6.86,2.51c0,.64-.06,1.28-.08,1.92-.12,3.08-.22,6.16-.41,9.17-.07,1.06-.18,2.11-.28,3.15-.06-.68-.13-1.26-.14-1.34-.57-2.67-3.24-7.48-6.27-7.79a3.61,3.61,0,0,0-3.88,3.72c0,2.16,1.73,4.17,3.35,5.4s5.37,2.16,6.66,2.46c-.13,1.07-.27,2.14-.45,3.16-.14.7-.22,1.39-.4,2.08l-.48,2c-.36,1.29-.71,2.63-1.09,3.88-.26.87-.52,1.7-.78,2.54.08-1.06.19-3.13.18-3.31-.15-2.71-2.06-7.88-5-8.64a3.61,3.61,0,0,0-4.39,3.09c-.33,2.13,1.07,4.38,2.49,5.84s6,3.37,6.56,3.59c-.44,1.38-.87,2.71-1.3,4-1.49,4.35-2.89,7.92-3.9,10.4,0,.09-.07.17-.11.25l1.82,1c.06-.16.13-.32.19-.49,1-2.53,2.31-6.17,3.71-10.6.45-1.4.9-2.9,1.35-4.45a38.8,38.8,0,0,0,4.6.3c.55,2.23,3.1,5.89,3.43,6.36-1.12.91-2.22,1.79-3.27,2.6-3.64,2.81-6.78,5-9,6.52l-.26.18,2,1.1c2.16-1.55,5-3.7,8.37-6.38,1.14-.92,2.35-1.93,3.57-3,.45.38,4.1,3.48,6.26,4.1,1.95.56,4.6.74,6.32-.55a3.61,3.61,0,0,0,.66-5.33c-2.06-2.25-7.51-1.5-10-.36-.14.07-1.64,1-2.58,1.56.5-.43,1-.84,1.49-1.29,1-.87,2-1.78,3.06-2.76l1.5-1.47c.51-.49,1-1.06,1.5-1.59,1.14-1.26,2.23-2.59,3.3-3.95.78.88,3.57,4,5.42,4.84s4.44,1.42,6.34.41a3.62,3.62,0,0,0,1.46-5.17c-1.7-2.53-7.2-2.62-9.82-1.87-.17.05-2,.8-3,1.23.63-.82,1.28-1.64,1.89-2.5,1.79-2.47,3.52-5,5.26-7.56l1.61-2.32c.27.31,3.51,4.07,5.59,5,1.84.85,4.43,1.43,6.33.41a3.6,3.6,0,0,0,1.46-5.17c-1.7-2.53-7.2-2.62-9.82-1.86-.19.05-2.81,1.14-3.46,1.45,1.18-1.7,2.38-3.39,3.63-5a61.82,61.82,0,0,1,5.42-6.21c.13.15,3.49,4.08,5.61,5.06,1.85.86,4.44,1.43,6.34.42a3.61,3.61,0,0,0,1.46-5.17c-1.7-2.54-7.2-2.62-9.82-1.87-.17.05-2.16.88-3.1,1.29l-.1-.15a46.79,46.79,0,0,1,6.49-5.15c1.27-.86,2.52-1.61,3.76-2.3.55.79,3.1,4.4,4.92,5.5s4.25,1.91,6.25,1.11a3.61,3.61,0,0,0,2-5c-1.41-2.71-6.87-3.39-9.55-2.93-.15,0-1.61.44-2.66.76l1.68-.92c2.05-1.06,4-1.92,5.71-2.66,1-.41,1.88-.77,2.72-1.09.95.5,4.79,2.47,6.87,2.6s4.66-.27,6.06-1.9A3.61,3.61,0,0,0,428.43,305.21Z",
    style: {
      fill: "#EDDBC6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.19,287.36c1.45,1.9,6.2,4.37,6.21,4.37s.68-3.62.69-3.86c.16-2.72-1.14-8.06-4-9.16a3.61,3.61,0,0,0-4.72,2.57C355.81,283.35,357,285.75,358.19,287.36Z",
    style: {
      fill: "#EDDBC6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.07,314.51c0,.05,2.57-2.65,2.71-2.84,1.63-2.18,3.5-7.36,1.73-9.85a3.61,3.61,0,0,0-5.35-.46c-1.62,1.42-2,4.05-1.86,6.08C402.47,309.82,405.07,314.5,405.07,314.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.43,305.21c-2.5-1.75-7.66.16-9.83,1.8-.19.15-2.87,2.71-2.82,2.73l.06,0c-.82.3-1.69.62-2.64,1-1.74.7-3.7,1.52-5.78,2.54a67.73,67.73,0,0,0-6.54,3.64,47,47,0,0,0-6.66,5.06.46.46,0,0,0-.07.07c.44-.77,1.61-3,1.68-3.16,1-2.54,1.43-8-.93-9.95a3.62,3.62,0,0,0-5.29,1c-1.18,1.8-.86,4.43-.18,6.35.76,2.17,4.21,5.75,4.49,6a63.23,63.23,0,0,0-5.76,6.29c-1,1.29-2.05,2.62-3,4,.36-.68.68-1.3.71-1.39,1-2.53,1.43-8-.93-9.95a3.61,3.61,0,0,0-5.28,1c-1.19,1.79-.86,4.43-.19,6.34s3.57,5.07,4.34,5.88L382.64,336c-1.8,2.51-3.58,5-5.41,7.42-.64.85-1.3,1.67-2,2.48.32-.61.59-1.12.62-1.2,1-2.54,1.43-8-.93-10a3.61,3.61,0,0,0-5.29,1c-1.19,1.8-.86,4.43-.18,6.35s3.28,4.76,4.19,5.73c-.7.82-1.4,1.63-2.12,2.39-.5.51-.94,1-1.48,1.51l-1.53,1.44c-1,.88-2,1.8-3.05,2.64-.7.59-1.37,1.13-2,1.68.64-.83,1.88-2.5,2-2.65a14,14,0,0,0,1.64-6.88,4.74,4.74,0,0,0,.34-.72,3.62,3.62,0,0,0-2.39-4.82c-3-.73-7.1,2.9-8.53,5.22-.08.14-.84,1.72-1.29,2.73.17-.63.36-1.25.53-1.9.36-1.29.68-2.59,1-4,.14-.68.29-1.37.44-2.06s.24-1.43.37-2.15c.25-1.68.43-3.39.58-5.12,1.13.31,5.16,1.36,7.18,1s4.49-1.26,5.51-3.15a3.6,3.6,0,0,0-1.63-5.12c-2.82-1.18-7.45,1.79-9.22,3.86-.11.13-1.21,1.76-1.8,2.67.08-1,.16-2.08.21-3.14.12-3,.16-6.13.21-9.21,0-.94,0-1.88.06-2.82.4.11,5.17,1.46,7.43,1.11,2-.3,4.49-1.25,5.52-3.15a3.62,3.62,0,0,0-1.64-5.12c-2.81-1.17-7.45,1.8-9.22,3.87-.13.15-1.71,2.5-2.09,3.12.05-2.07.12-4.14.27-6.17a64.83,64.83,0,0,1,1.1-8.17c.19,0,5.16,1.48,7.48,1.12,2-.3,4.48-1.25,5.51-3.15a3.62,3.62,0,0,0-1.63-5.12c-2.82-1.17-7.46,1.79-9.22,3.87-.12.13-1.33,1.92-1.88,2.78l-.16-.06a46.16,46.16,0,0,1,2.57-7.89c.58-1.41,1.21-2.72,1.86-4,.9.36,5,2,7.14,1.88s4.6-.76,5.83-2.53a3.62,3.62,0,0,0-1.06-5.27c-2.67-1.47-7.61,1-9.59,2.83-.11.1-1.09,1.25-1.8,2.1.3-.56.6-1.15.9-1.69,1.12-2,2.26-3.8,3.29-5.37.59-.88,1.14-1.67,1.67-2.41,1.06-.1,5.36-.59,7.17-1.62s3.73-2.79,4-4.93a3.6,3.6,0,0,0-3.37-4.18c-3.05-.08-6.3,4.35-7.2,6.92-.08.23-.9,3.84-.85,3.83h.07q-.78,1-1.65,2.28c-1.07,1.55-2.26,3.31-3.42,5.31a65,65,0,0,0-3.45,6.64,48,48,0,0,0-2.77,7.9.3.3,0,0,1,0,.1c0-.89-.3-3.38-.34-3.57-.56-2.66-3.23-7.48-6.26-7.78a3.61,3.61,0,0,0-3.88,3.72c0,2.15,1.73,4.17,3.35,5.39,1.83,1.39,6.68,2.48,7.07,2.56a65,65,0,0,0-1.33,8.43c-.15,1.65-.26,3.31-.35,5-.07-.77-.14-1.46-.16-1.55-.57-2.67-3.24-7.48-6.27-7.79a3.61,3.61,0,0,0-3.88,3.72c0,2.15,1.73,4.17,3.35,5.4s5.77,2.25,6.86,2.51c0,.64-.06,1.28-.08,1.92-.12,3.08-.22,6.16-.41,9.17-.07,1.06-.18,2.11-.28,3.15-.06-.68-.13-1.26-.14-1.34-.57-2.67-3.24-7.48-6.27-7.79a3.61,3.61,0,0,0-3.88,3.72c0,2.16,1.73,4.17,3.35,5.4s5.37,2.16,6.66,2.46c-.13,1.07-.27,2.14-.45,3.16-.14.7-.22,1.39-.4,2.08l-.48,2c-.36,1.29-.71,2.63-1.09,3.88-.26.87-.52,1.7-.78,2.54.08-1.06.19-3.13.18-3.31-.15-2.71-2.06-7.88-5-8.64a3.61,3.61,0,0,0-4.39,3.09c-.33,2.13,1.07,4.38,2.49,5.84s6,3.37,6.56,3.59c-.44,1.38-.87,2.71-1.3,4-1.49,4.35-2.89,7.92-3.9,10.4,0,.09-.07.17-.11.25l1.82,1c.06-.16.13-.32.19-.49,1-2.53,2.31-6.17,3.71-10.6.45-1.4.9-2.9,1.35-4.45a38.8,38.8,0,0,0,4.6.3c.55,2.23,3.1,5.89,3.43,6.36-1.12.91-2.22,1.79-3.27,2.6-3.64,2.81-6.78,5-9,6.52l-.26.18,2,1.1c2.16-1.55,5-3.7,8.37-6.38,1.14-.92,2.35-1.93,3.57-3,.45.38,4.1,3.48,6.26,4.1,1.95.56,4.6.74,6.32-.55a3.61,3.61,0,0,0,.66-5.33c-2.06-2.25-7.51-1.5-10-.36-.14.07-1.64,1-2.58,1.56.5-.43,1-.84,1.49-1.29,1-.87,2-1.78,3.06-2.76l1.5-1.47c.51-.49,1-1.06,1.5-1.59,1.14-1.26,2.23-2.59,3.3-3.95.78.88,3.57,4,5.42,4.84s4.44,1.42,6.34.41a3.62,3.62,0,0,0,1.46-5.17c-1.7-2.53-7.2-2.62-9.82-1.87-.17.05-2,.8-3,1.23.63-.82,1.28-1.64,1.89-2.5,1.79-2.47,3.52-5,5.26-7.56l1.61-2.32c.27.31,3.51,4.07,5.59,5,1.84.85,4.43,1.43,6.33.41a3.6,3.6,0,0,0,1.46-5.17c-1.7-2.53-7.2-2.62-9.82-1.86-.19.05-2.81,1.14-3.46,1.45,1.18-1.7,2.38-3.39,3.63-5a61.82,61.82,0,0,1,5.42-6.21c.13.15,3.49,4.08,5.61,5.06,1.85.86,4.44,1.43,6.34.42a3.61,3.61,0,0,0,1.46-5.17c-1.7-2.54-7.2-2.62-9.82-1.87-.17.05-2.16.88-3.1,1.29l-.1-.15a46.79,46.79,0,0,1,6.49-5.15c1.27-.86,2.52-1.61,3.76-2.3.55.79,3.1,4.4,4.92,5.5s4.25,1.91,6.25,1.11a3.61,3.61,0,0,0,2-5c-1.41-2.71-6.87-3.39-9.55-2.93-.15,0-1.61.44-2.66.76l1.68-.92c2.05-1.06,4-1.92,5.71-2.66,1-.41,1.88-.77,2.72-1.09.95.5,4.79,2.47,6.87,2.6s4.66-.27,6.06-1.9A3.61,3.61,0,0,0,428.43,305.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.19,287.36c1.45,1.9,6.2,4.37,6.21,4.37s.68-3.62.69-3.86c.16-2.72-1.14-8.06-4-9.16a3.61,3.61,0,0,0-4.72,2.57C355.81,283.35,357,285.75,358.19,287.36Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163,236.8c.06,0-.78-4.19-.87-4.44-1-3-4.6-8.21-8.12-8.2a4.17,4.17,0,0,0-4,4.74c.26,2.47,2.48,4.58,4.49,5.79C156.84,236.12,163,236.8,163,236.8Z",
    style: {
      fill: "#EDDBC6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.81,208.59c-3.32,1.19-5,7.33-4.86,10.47,0,.27.63,4.5.69,4.47l.07,0c-.27,1-.54,2-.82,3.15-.5,2.11-1,4.5-1.46,7.14a76.53,76.53,0,0,0-.94,8.59,54.53,54.53,0,0,0,.33,9.65.5.5,0,0,1,0,.12c-.43-.94-1.73-3.51-1.86-3.7-1.72-2.63-6.6-6.7-10-5.76a4.18,4.18,0,0,0-2.61,5.63c.9,2.31,3.6,3.76,5.86,4.4,2.55.73,8.23-.13,8.68-.2a73.32,73.32,0,0,0,2.09,9.62c.52,1.84,1.1,3.68,1.71,5.52-.4-.8-.77-1.51-.83-1.6-1.73-2.63-6.6-6.7-10-5.76a4.16,4.16,0,0,0-2.61,5.62c.9,2.32,3.6,3.77,5.86,4.41s7.14,0,8.43-.17c.24.7.47,1.41.71,2.11,1.16,3.36,2.34,6.72,3.39,10,.37,1.17.69,2.34,1,3.5-.36-.71-.66-1.3-.72-1.38-1.72-2.63-6.6-6.7-10-5.76a4.16,4.16,0,0,0-2.61,5.62c.9,2.32,3.6,3.77,5.86,4.41s6.67.08,8.2-.14c.3,1.21.6,2.41.83,3.59.15.81.34,1.58.44,2.41s.22,1.61.34,2.4c.16,1.54.33,3.13.45,4.64.09,1,.15,2,.22,3-.35-1.17-1.1-3.45-1.18-3.63a16.27,16.27,0,0,0-5.39-6.14,4.88,4.88,0,0,0-.46-.8,4.18,4.18,0,0,0-6.13-1c-2.66,2.31-2,8.62-.77,11.52.07.17,1.07,1.93,1.71,3-.48-.59-.93-1.17-1.43-1.78-1-1.19-2-2.36-3.08-3.62l-1.65-1.79c-.54-.61-1.18-1.18-1.78-1.78-1.4-1.36-2.9-2.67-4.43-4,1-.86,4.72-4,5.78-6.07s1.8-5.07.7-7.3a4.16,4.16,0,0,0-5.91-1.87c-3,1.87-3.28,8.21-2.51,11.26.05.19.85,2.31,1.31,3.47-.93-.76-1.85-1.53-2.81-2.28-2.79-2.15-5.67-4.24-8.54-6.34-.88-.64-1.75-1.3-2.62-1.94.38-.31,4.83-3.9,6-6.26,1.05-2.1,1.81-5.07.71-7.3a4.16,4.16,0,0,0-5.91-1.87c-3,1.87-3.29,8.21-2.51,11.26,0,.23,1.21,3.29,1.54,4.05-1.92-1.43-3.81-2.87-5.63-4.37a74.57,74.57,0,0,1-7-6.48c.18-.14,4.84-3.87,6-6.29,1.05-2.1,1.81-5.07.71-7.3a4.16,4.16,0,0,0-5.91-1.87c-3,1.87-3.29,8.21-2.51,11.26,0,.2.93,2.53,1.37,3.63l-.17.1a53.25,53.25,0,0,1-5.72-7.68c-.94-1.48-1.75-3-2.51-4.41.93-.61,5.2-3.42,6.53-5.48s2.35-4.84,1.5-7.17a4.17,4.17,0,0,0-5.67-2.52c-3.17,1.54-4.16,7.81-3.73,10.92,0,.17.45,1.87.78,3.1-.33-.66-.68-1.34-1-2-1.16-2.4-2.07-4.66-2.87-6.68-.44-1.15-.81-2.19-1.15-3.18.61-1.07,3-5.44,3.24-7.83s-.13-5.38-2-7.06a4.17,4.17,0,0,0-6.19.38c-2.1,2.82-.09,8.85,1.73,11.41.15.22,3,3.41,3,3.35l0-.07c.31,1,.65,2,1,3.08.75,2,1.62,4.33,2.73,6.76a73.11,73.11,0,0,0,3.95,7.68,55.38,55.38,0,0,0,5.6,7.88l.08.08c-.88-.54-3.38-2-3.59-2.06-2.89-1.24-9.2-1.94-11.52.71a4.18,4.18,0,0,0,.93,6.14c2,1.43,5.08,1.15,7.31.44,2.53-.8,6.79-4.65,7.13-5a74,74,0,0,0,7,6.87c1.45,1.25,2.95,2.47,4.47,3.66l-1.57-.88c-2.89-1.24-9.2-1.94-11.52.72a4.17,4.17,0,0,0,.92,6.13c2,1.44,5.08,1.15,7.32.44s6-3.92,6.94-4.79l1.76,1.37c2.83,2.16,5.66,4.31,8.37,6.5.95.77,1.86,1.57,2.78,2.36-.69-.39-1.27-.72-1.37-.76-2.88-1.24-9.2-1.94-11.51.71a4.18,4.18,0,0,0,.92,6.14c2,1.43,5.08,1.15,7.32.44s5.61-3.62,6.76-4.64c.92.84,1.83,1.68,2.68,2.54.57.59,1.15,1.13,1.69,1.76l1.61,1.82c1,1.2,2,2.43,2.93,3.62.65.82,1.26,1.62,1.87,2.42-.94-.78-2.82-2.27-3-2.37-2.67-1.67-8.8-3.32-11.49-1a4.16,4.16,0,0,0,0,6.2c1.79,1.73,4.85,1.91,7.17,1.55,2.55-.4,7.18-3.42,7.75-3.8,1,1.33,2,2.63,2.87,3.88,3.12,4.3,5.55,8,7.21,10.61l.17.27,2.15-1.05-.34-.51c-1.74-2.6-4.27-6.29-7.51-10.56-1-1.36-2.13-2.78-3.29-4.23a47.06,47.06,0,0,0,3.34-4.14c2.47,1,7.63,1,8.29,1,.11,1.67.2,3.29.26,4.82.22,5.3.21,9.73.15,12.83v.36l2.36-1.15c0-3.08-.11-7.23-.43-12.15-.1-1.69-.24-3.5-.41-5.35.66-.16,6-1.54,8-3.15,1.83-1.47,3.76-3.85,3.7-6.33a4.17,4.17,0,0,0-4.59-4.18c-3.49.45-6.42,6.08-7,9.18,0,.18-.18,2.2-.26,3.47-.07-.75-.13-1.49-.21-2.27-.16-1.53-.36-3.07-.57-4.71l-.39-2.41c-.11-.8-.33-1.63-.5-2.46-.42-1.92-.94-3.83-1.51-5.76,1.34-.13,6.12-.7,8.17-1.87s4.3-3.23,4.61-5.7a4.16,4.16,0,0,0-3.9-4.82c-3.52-.09-7.27,5-8.3,8-.07.18-.57,2.4-.83,3.62-.35-1.15-.69-2.3-1.08-3.46-1.14-3.33-2.39-6.66-3.63-10l-1.11-3.06c.48-.05,6.18-.59,8.47-1.91,2-1.17,4.3-3.23,4.61-5.69a4.17,4.17,0,0,0-3.9-4.83c-3.52-.08-7.27,5-8.3,8-.08.23-.8,3.41-.95,4.23-.81-2.25-1.6-4.5-2.28-6.75a72.26,72.26,0,0,1-2.24-9.25c.22,0,6.17-.56,8.52-1.91,2-1.17,4.3-3.23,4.61-5.7a4.17,4.17,0,0,0-3.9-4.82c-3.52-.09-7.27,5-8.3,8-.07.2-.62,2.62-.86,3.78h-.2a54.09,54.09,0,0,1-.53-9.56c0-1.76.17-3.44.33-5.07,1.12,0,6.23,0,8.47-1s4.64-2.73,5.22-5.15a4.16,4.16,0,0,0-3.35-5.22c-3.49-.48-7.78,4.21-9.13,7-.08.16-.65,1.81-1.06,3,.09-.74.17-1.5.26-2.2.36-2.64.85-5,1.3-7.15.27-1.2.53-2.28.79-3.29,1.1-.56,5.52-2.87,7-4.75s2.85-4.56,2.25-7A4.17,4.17,0,0,0,169.81,208.59Z",
    style: {
      fill: "#EDDBC6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.15,262.87c2.75-.11,8.25-2.93,8.26-2.93s-3-3.06-3.18-3.23c-2.46-2-8.36-4.3-11.29-2.36a4.16,4.16,0,0,0-.73,6.16C100.79,262.44,103.8,263,106.15,262.87Z",
    style: {
      fill: "#EDDBC6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163,236.8c.06,0-.78-4.19-.87-4.44-1-3-4.6-8.21-8.12-8.2a4.17,4.17,0,0,0-4,4.74c.26,2.47,2.48,4.58,4.49,5.79C156.84,236.12,163,236.8,163,236.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.81,208.59c-3.32,1.19-5,7.33-4.86,10.47,0,.27.63,4.5.69,4.47l.07,0c-.27,1-.54,2-.82,3.15-.5,2.11-1,4.5-1.46,7.14a76.53,76.53,0,0,0-.94,8.59,54.53,54.53,0,0,0,.33,9.65.5.5,0,0,1,0,.12c-.43-.94-1.73-3.51-1.86-3.7-1.72-2.63-6.6-6.7-10-5.76a4.18,4.18,0,0,0-2.61,5.63c.9,2.31,3.6,3.76,5.86,4.4,2.55.73,8.23-.13,8.68-.2a73.32,73.32,0,0,0,2.09,9.62c.52,1.84,1.1,3.68,1.71,5.52-.4-.8-.77-1.51-.83-1.6-1.73-2.63-6.6-6.7-10-5.76a4.16,4.16,0,0,0-2.61,5.62c.9,2.32,3.6,3.77,5.86,4.41s7.14,0,8.43-.17c.24.7.47,1.41.71,2.11,1.16,3.36,2.34,6.72,3.39,10,.37,1.17.69,2.34,1,3.5-.36-.71-.66-1.3-.72-1.38-1.72-2.63-6.6-6.7-10-5.76a4.16,4.16,0,0,0-2.61,5.62c.9,2.32,3.6,3.77,5.86,4.41s6.67.08,8.2-.14c.3,1.21.6,2.41.83,3.59.15.81.34,1.58.44,2.41s.22,1.61.34,2.4c.16,1.54.33,3.13.45,4.64.09,1,.15,2,.22,3-.35-1.17-1.1-3.45-1.18-3.63a16.27,16.27,0,0,0-5.39-6.14,4.88,4.88,0,0,0-.46-.8,4.18,4.18,0,0,0-6.13-1c-2.66,2.31-2,8.62-.77,11.52.07.17,1.07,1.93,1.71,3-.48-.59-.93-1.17-1.43-1.78-1-1.19-2-2.36-3.08-3.62l-1.65-1.79c-.54-.61-1.18-1.18-1.78-1.78-1.4-1.36-2.9-2.67-4.43-4,1-.86,4.72-4,5.78-6.07s1.8-5.07.7-7.3a4.16,4.16,0,0,0-5.91-1.87c-3,1.87-3.28,8.21-2.51,11.26.05.19.85,2.31,1.31,3.47-.93-.76-1.85-1.53-2.81-2.28-2.79-2.15-5.67-4.24-8.54-6.34-.88-.64-1.75-1.3-2.62-1.94.38-.31,4.83-3.9,6-6.26,1.05-2.1,1.81-5.07.71-7.3a4.16,4.16,0,0,0-5.91-1.87c-3,1.87-3.29,8.21-2.51,11.26,0,.23,1.21,3.29,1.54,4.05-1.92-1.43-3.81-2.87-5.63-4.37a74.57,74.57,0,0,1-7-6.48c.18-.14,4.84-3.87,6-6.29,1.05-2.1,1.81-5.07.71-7.3a4.16,4.16,0,0,0-5.91-1.87c-3,1.87-3.29,8.21-2.51,11.26,0,.2.93,2.53,1.37,3.63l-.17.1a53.25,53.25,0,0,1-5.72-7.68c-.94-1.48-1.75-3-2.51-4.41.93-.61,5.2-3.42,6.53-5.48s2.35-4.84,1.5-7.17a4.17,4.17,0,0,0-5.67-2.52c-3.17,1.54-4.16,7.81-3.73,10.92,0,.17.45,1.87.78,3.1-.33-.66-.68-1.34-1-2-1.16-2.4-2.07-4.66-2.87-6.68-.44-1.15-.81-2.19-1.15-3.18.61-1.07,3-5.44,3.24-7.83s-.13-5.38-2-7.06a4.17,4.17,0,0,0-6.19.38c-2.1,2.82-.09,8.85,1.73,11.41.15.22,3,3.41,3,3.35l0-.07c.31,1,.65,2,1,3.08.75,2,1.62,4.33,2.73,6.76a73.11,73.11,0,0,0,3.95,7.68,55.38,55.38,0,0,0,5.6,7.88l.08.08c-.88-.54-3.38-2-3.59-2.06-2.89-1.24-9.2-1.94-11.52.71a4.18,4.18,0,0,0,.93,6.14c2,1.43,5.08,1.15,7.31.44,2.53-.8,6.79-4.65,7.13-5a74,74,0,0,0,7,6.87c1.45,1.25,2.95,2.47,4.47,3.66l-1.57-.88c-2.89-1.24-9.2-1.94-11.52.72a4.17,4.17,0,0,0,.92,6.13c2,1.44,5.08,1.15,7.32.44s6-3.92,6.94-4.79l1.76,1.37c2.83,2.16,5.66,4.31,8.37,6.5.95.77,1.86,1.57,2.78,2.36-.69-.39-1.27-.72-1.37-.76-2.88-1.24-9.2-1.94-11.51.71a4.18,4.18,0,0,0,.92,6.14c2,1.43,5.08,1.15,7.32.44s5.61-3.62,6.76-4.64c.92.84,1.83,1.68,2.68,2.54.57.59,1.15,1.13,1.69,1.76l1.61,1.82c1,1.2,2,2.43,2.93,3.62.65.82,1.26,1.62,1.87,2.42-.94-.78-2.82-2.27-3-2.37-2.67-1.67-8.8-3.32-11.49-1a4.16,4.16,0,0,0,0,6.2c1.79,1.73,4.85,1.91,7.17,1.55,2.55-.4,7.18-3.42,7.75-3.8,1,1.33,2,2.63,2.87,3.88,3.12,4.3,5.55,8,7.21,10.61l.17.27,2.15-1.05-.34-.51c-1.74-2.6-4.27-6.29-7.51-10.56-1-1.36-2.13-2.78-3.29-4.23a47.06,47.06,0,0,0,3.34-4.14c2.47,1,7.63,1,8.29,1,.11,1.67.2,3.29.26,4.82.22,5.3.21,9.73.15,12.83v.36l2.36-1.15c0-3.08-.11-7.23-.43-12.15-.1-1.69-.24-3.5-.41-5.35.66-.16,6-1.54,8-3.15,1.83-1.47,3.76-3.85,3.7-6.33a4.17,4.17,0,0,0-4.59-4.18c-3.49.45-6.42,6.08-7,9.18,0,.18-.18,2.2-.26,3.47-.07-.75-.13-1.49-.21-2.27-.16-1.53-.36-3.07-.57-4.71l-.39-2.41c-.11-.8-.33-1.63-.5-2.46-.42-1.92-.94-3.83-1.51-5.76,1.34-.13,6.12-.7,8.17-1.87s4.3-3.23,4.61-5.7a4.16,4.16,0,0,0-3.9-4.82c-3.52-.09-7.27,5-8.3,8-.07.18-.57,2.4-.83,3.62-.35-1.15-.69-2.3-1.08-3.46-1.14-3.33-2.39-6.66-3.63-10l-1.11-3.06c.48-.05,6.18-.59,8.47-1.91,2-1.17,4.3-3.23,4.61-5.69a4.17,4.17,0,0,0-3.9-4.83c-3.52-.08-7.27,5-8.3,8-.08.23-.8,3.41-.95,4.23-.81-2.25-1.6-4.5-2.28-6.75a72.26,72.26,0,0,1-2.24-9.25c.22,0,6.17-.56,8.52-1.91,2-1.17,4.3-3.23,4.61-5.7a4.17,4.17,0,0,0-3.9-4.82c-3.52-.09-7.27,5-8.3,8-.07.2-.62,2.62-.86,3.78h-.2a54.09,54.09,0,0,1-.53-9.56c0-1.76.17-3.44.33-5.07,1.12,0,6.23,0,8.47-1s4.64-2.73,5.22-5.15a4.16,4.16,0,0,0-3.35-5.22c-3.49-.48-7.78,4.21-9.13,7-.08.16-.65,1.81-1.06,3,.09-.74.17-1.5.26-2.2.36-2.64.85-5,1.3-7.15.27-1.2.53-2.28.79-3.29,1.1-.56,5.52-2.87,7-4.75s2.85-4.56,2.25-7A4.17,4.17,0,0,0,169.81,208.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.15,262.87c2.75-.11,8.25-2.93,8.26-2.93s-3-3.06-3.18-3.23c-2.46-2-8.36-4.3-11.29-2.36a4.16,4.16,0,0,0-.73,6.16C100.79,262.44,103.8,263,106.15,262.87Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.76,338.39s16.7-40.25,26.05-38.5-16,64.17-16,64.17,29.38-55.42,49.42-55.42-7.35,61.25-32.72,81.67c0,0,40.06-43.17,63.43-33.83s-46.74,53.08-46.74,53.08,40.73-12.83,36.06-2.91-17.36,11.66-17.36,11.66l46.07,2.34H87.68l36.06-3.5s-37.4-18.67-27.38-26.25,32.05,8.75,32.05,8.75-38.06-42-30.72-57.76,40.07,28.59,40.07,28.59S111.05,313.89,116.39,304,139.76,338.39,139.76,338.39Z",
    style: {
      fill: "#EDDBC6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.76,338.39s16.7-40.25,26.05-38.5-16,64.17-16,64.17,29.38-55.42,49.42-55.42-7.35,61.25-32.72,81.67c0,0,40.06-43.17,63.43-33.83s-46.74,53.08-46.74,53.08,40.73-12.83,36.06-2.91-17.36,11.66-17.36,11.66l46.07,2.34H87.68l36.06-3.5s-37.4-18.67-27.38-26.25,32.05,8.75,32.05,8.75-38.06-42-30.72-57.76,40.07,28.59,40.07,28.59S111.05,313.89,116.39,304,139.76,338.39,139.76,338.39Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.42,340.51c14.69,43.41,14.69,74.13,14.69,74.13s-17.36.66-35.39-12.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.77,363.89a260.35,260.35,0,0,1,12-38.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.17,338.51l-37.39,55.43s-25.38-21.37-34.06-33.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.45,407.29s39.39-18.7,55.42-29.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.19,338.39s-16.69-40.25-26-38.5,16,64.17,16,64.17-29.38-55.42-49.41-55.42,7.34,61.25,32.72,81.67c0,0-40.07-43.17-63.44-33.83s46.75,53.08,46.75,53.08-40.74-12.83-36.06-2.91,17.36,11.66,17.36,11.66L247,420.65H407.28l-36.06-3.5s37.39-18.67,27.38-26.25-32.06,8.75-32.06,8.75,38.07-42,30.72-57.76-40.07,28.59-40.07,28.59,26.72-56.59,21.37-66.51S355.19,338.39,355.19,338.39Z",
    style: {
      fill: "#EDDBC6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.19,338.39s-16.69-40.25-26-38.5,16,64.17,16,64.17-29.38-55.42-49.41-55.42,7.34,61.25,32.72,81.67c0,0-40.07-43.17-63.44-33.83s46.75,53.08,46.75,53.08-40.74-12.83-36.06-2.91,17.36,11.66,17.36,11.66L247,420.65H407.28l-36.06-3.5s37.39-18.67,27.38-26.25-32.06,8.75-32.06,8.75,38.07-42,30.72-57.76-40.07,28.59-40.07,28.59,26.72-56.59,21.37-66.51S355.19,338.39,355.19,338.39Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.53,340.51c-14.69,43.41-14.69,74.13-14.69,74.13s17.36.66,35.39-12.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.19,363.89a260.35,260.35,0,0,0-12-38.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.78,338.51l37.4,55.43s25.37-21.37,34.05-33.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.51,407.29s-39.4-18.7-55.43-29.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-79"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.08,
    y: 121.5,
    width: 167.9,
    height: 302.59,
    rx: 6.75,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.64,139.58h-20.9a2.15,2.15,0,0,1-2.15-2.15h0a2.14,2.14,0,0,1,2.15-2.14h20.9a2.14,2.14,0,0,1,2.14,2.14h0A2.14,2.14,0,0,1,262.64,139.58Z",
    style: {
      fill: "#EDDBC6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.37,397.05H177.69V139.83h34.77l3.91,3.24a7.56,7.56,0,0,0,4.86,1.76h61.34a7.64,7.64,0,0,0,5-1.9l3.53-3.1h33.24Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.938618px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.27 158.79 234.27 152.07 184.35 152.07 184.35 158.79 184.35 383.39 184.35 390.12 318.16 390.12 318.16 158.79 236.27 158.79",
    style: {
      fill: "#EDDBC6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.05,
    y: 170.9,
    width: 124.4,
    height: 211.82,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.72,405a3.34,3.34,0,1,0-3.34,3.33A3.35,3.35,0,0,0,255.72,405Z",
    style: {
      fill: "#EDDBC6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Message--inject-79"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 241.91,
    cy: 315.19,
    rx: 40.96,
    ry: 58.28,
    style: {
      fill: "#EDDBC6"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 241.91,
    cy: 315.19,
    rx: 40.96,
    ry: 58.28,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.72,250.14s-2.56-4.28-4.91-4.49S212.48,263,208.2,272.14s-8.33,27.48,3,45.13c11.05,17.17,28.37,16.6,37.35,15.74s15-3.78,24.1-11.08,17.45-18.05,18.66-25.35-3.24-11.36-6.08-12.37-19.27-.81-31.24-13S247.72,250.14,247.72,250.14Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.35,244.58s-7.26,2.78-11.75,7.69-7.26,12.61-7.47,23.93,3.42,24.13,17.51,29.69,26.7,1.28,30.76-2.57,9-14.73,9-14.73-22.42,6-33.1-6.63S251.35,244.58,251.35,244.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.83,252.47c-5.48-8.22-18.56-10.65-28.9-14s-16.43-10-13.69-26.46,17-43.2,16.73-48.07-49.28-4.56-53.85-3-5.47,1.21-9.73,6.69A75.83,75.83,0,0,0,281,177l5.28-11.1.39,0a14,14,0,0,1,2.41-4,30.75,30.75,0,0,0,7.45-19.34c.2-10.47-7.25-9.46-8.66-6.24s-9.66,14.3-12.08,17.32-7.45,11.28-7.45,11.28l-5.59,19.38s-1.22,5.78-8.22,27.69S250.58,244,250.58,244s-1.83-.91-6.09,12.17-2.43,29.81,5.17,37.72,17.65,7.61,28.91,3.05A34.61,34.61,0,0,0,295,282.28s11.87-3,20.69-9.73S331.2,258.86,344,259.47s27.38,7.91,32.25,7.6S382.31,260.68,376.83,252.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-79)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.36,224c-33.85,5.05-44.49,13.13-41.11,24.25a17.19,17.19,0,0,0,3.35,6c0,.21,0,.44.06.68,0,0,.6.36,1.5,1a28.69,28.69,0,0,0,3.83,3.11c2.22,2.11,4.21,4.75,3.8,7.2-.87,5.22-13,14.34-19.13,14.78s-8.26-5.65-9.13.87,12.61,22.6,25.65,20.86,23.91-20,23.91-20-1.74-3,7-12.17c5.74-6,13.95-8.65,20.24-11.11a115.67,115.67,0,0,0,17.31-6.64c15.47-7.58,33.85-2.52,33.85-2.52S332.21,218.89,298.36,224Z",
    style: {
      fill: "#EDDBC6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.36,224c-33.85,5.05-44.49,13.13-41.11,24.25a17.19,17.19,0,0,0,3.35,6c0,.21,0,.44.06.68,0,0,.6.36,1.5,1a28.69,28.69,0,0,0,3.83,3.11c2.22,2.11,4.21,4.75,3.8,7.2-.87,5.22-13,14.34-19.13,14.78s-8.26-5.65-9.13.87,12.61,22.6,25.65,20.86,23.91-20,23.91-20-1.74-3,7-12.17c5.74-6,13.95-8.65,20.24-11.11a115.67,115.67,0,0,0,17.31-6.64c15.47-7.58,33.85-2.52,33.85-2.52S332.21,218.89,298.36,224Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M376.83,252.47c-5.48-8.22-18.56-10.65-28.9-14s-16.43-10-13.69-26.46,17-43.2,16.73-48.07-49.28-4.56-53.85-3-5.47,1.21-9.73,6.69A75.83,75.83,0,0,0,281,177l5.28-11.1.39,0a14,14,0,0,1,2.41-4,30.75,30.75,0,0,0,7.45-19.34c.2-10.47-7.25-9.46-8.66-6.24s-9.66,14.3-12.08,17.32-7.45,11.28-7.45,11.28l-5.59,19.38s-1.22,5.78-8.22,27.69S250.58,244,250.58,244s-1.83-.91-6.09,12.17-2.43,29.81,5.17,37.72,17.65,7.61,28.91,3.05A34.61,34.61,0,0,0,295,282.28s11.87-3,20.69-9.73S331.2,258.86,344,259.47s27.38,7.91,32.25,7.6S382.31,260.68,376.83,252.47Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,267s.64-2.56-6.62-6-10.25-1.07-10.25.64S375.88,267,377,267Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.21,149.83l-18.32,14.1h24.57S314.46,146.61,308.21,149.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.23,251.53a25.6,25.6,0,0,1,9.48-6.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.9,257a12.28,12.28,0,0,1,1.09-2.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.6,276a26.86,26.86,0,0,1-2.74-2.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,282.28a26.82,26.82,0,0,1-16.3-3.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.5,162.72H271.18c-12.75,0-23.08,9.87-23.08,22v43.5c0,10.58,7.81,19.42,18.23,21.55l-4.87,14.41L284,250.3H363.5c12.74,0,23.08-9.87,23.08-22v-43.5C386.58,172.59,376.24,162.72,363.5,162.72Z",
    style: {
      fill: "#EDDBC6",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.13,
    y1: 192.01,
    x2: 366.91,
    y2: 192.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.06409px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.13,
    y1: 202.7,
    x2: 366.91,
    y2: 202.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.06409px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.13,
    y1: 213.38,
    x2: 366.91,
    y2: 213.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.06409px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.13,
    y1: 224.06,
    x2: 366.91,
    y2: 224.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.06409px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 385.74,
    cy: 188.56,
    rx: 12.87,
    ry: 12.29,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.74,197.24a5.31,5.31,0,0,1-.55-2.73v-10l-2.26,1.26a1.64,1.64,0,0,1-.8.22,1.49,1.49,0,0,1-1.12-.49,1.61,1.61,0,0,1-.45-1.14,1.38,1.38,0,0,1,.24-.81,3.39,3.39,0,0,1,.82-.71L385,180.6a3.46,3.46,0,0,1,1.66-.63c1.49,0,2.23,1.12,2.23,3.36v11.53c0,2.19-.78,3.28-2.35,3.28A1.92,1.92,0,0,1,384.74,197.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.36,156.28s.41,8.05,7.66,11.88,16.51,3,16.71-1.81-5.44-9.87-9.26-16.32-12.29-2.81-15.91,1.62",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.85,162.72c-.61,3.22,1.61,5,3.62,6s6,.41,8.26-2.41c.1-2.36-1.19-4.76-3-7.35C355.21,159.28,349.32,160.2,348.85,162.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.26,156.28s.4,8.05,7.65,11.88,16.52,3,16.72-1.81-5.44-9.87-9.27-16.32-12.28-2.81-15.91,1.62",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.75,162.72c-.61,3.22,1.61,5,3.62,6s6,.41,8.26-2.41c.09-2.36-1.2-4.76-3-7.35C340.11,159.28,334.22,160.2,333.75,162.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.21,156.28s.4,8.05,7.65,11.88,16.51,3,16.71-1.81-5.43-9.87-9.26-16.32-12.29-2.81-15.91,1.62",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.69,162.72c-.6,3.22,1.61,5,3.63,6s6,.41,8.25-2.41c.1-2.36-1.19-4.76-3-7.35C326.05,159.28,320.16,160.2,319.69,162.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.58,244s.56,12.38,7.39,20.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.7,295.67c0,2.52-1.68,4.56-3.75,4.56s-3.75-2-3.75-4.56,1.68-4.56,3.75-4.56S230.7,293.15,230.7,295.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.37,301.35c0,2.52-1.68,4.56-3.75,4.56s-3.75-2-3.75-4.56,1.68-4.57,3.75-4.57S221.37,298.83,221.37,301.35Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewEmailIllustration);
export default __webpack_public_path__ + "static/media/new-email-illustration.2c09f079908eeda59d40e9c779d9eec2.svg";
export { ForwardRef as ReactComponent };